import { CARD_TYPE_MAP, CardType } from '@zola/zola-ui/src/paper/cards/constants/cardTypes';

export const HOLIDAY_COLORS = [
  'BLUE',
  'GREEN',
  'BLACK',
  'PINK',
  'PURPLE',
  'WHITE',
  'RED',
  'BEIGE',
  'GREY',
  'ORANGE',
  'YELLOW',
  'BROWN',
] as const;

export const NAPKIN_COLORS = [
  'WHITE',
  'NAVY',
  'BLACK',
  'EMERALD_GREEN',
  'SILVER',
  'LAVENDER',
  'BEIGE',
  'BURGUNDY',
  'ROSE',
  'GOLD',
] as const;

export const SEO_COLORS = [
  'MULTI',
  'BLUE',
  'DUSTY_BLUE',
  'ROYAL_BLUE',
  'NAVY',
  'BLACK',
  'RED',
  'BURGUNDY',
  'WHITE',
  'PURPLE',
  'LAVENDER',
  'PLUM',
  'PINK',
  'ROSE',
  'DUSTY_ROSE',
  'CORAL',
  'PEACH',
  'GREEN',
  'EMERALD_GREEN',
  'TEAL',
  'ORANGE',
  'YELLOW',
  'GREY',
  'BROWN',
  'BEIGE',
] as const;

export type SeoColor = typeof SEO_COLORS[number];

export const isSeoColorType = (type?: string): type is SeoColor => {
  if (!type) return false;
  return (SEO_COLORS as Readonly<string[]>).includes(type);
};

export const getColorOptionList = (cardType: CardType) => {
  switch (cardType) {
    case CARD_TYPE_MAP.holiday:
      return HOLIDAY_COLORS;
    case CARD_TYPE_MAP.napkin:
      return NAPKIN_COLORS;
    default:
      return SEO_COLORS;
  }
};
